// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-3.use[1]!../../../../../node_modules/vue-loader/dist/stylePostLoader.js!../../../../../node_modules/less-loader/dist/cjs.js!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[1].rules[8].use[0]!./tariffsWidget.vue?vue&type=style&index=0&id=00bb145d&module=true&lang=less");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("34dae8a5", content, false, {});
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-3.use[1]!../../../../../node_modules/vue-loader/dist/stylePostLoader.js!../../../../../node_modules/less-loader/dist/cjs.js!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[1].rules[8].use[0]!./tariffsWidget.vue?vue&type=style&index=0&id=00bb145d&module=true&lang=less", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-3.use[1]!../../../../../node_modules/vue-loader/dist/stylePostLoader.js!../../../../../node_modules/less-loader/dist/cjs.js!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[1].rules[8].use[0]!./tariffsWidget.vue?vue&type=style&index=0&id=00bb145d&module=true&lang=less");
     if(newContent.__esModule) newContent = newContent.default;
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}